<nz-page-header class="site-page-header">
  <nz-breadcrumb nz-page-header-breadcrumb>
    <nz-breadcrumb-item>
      <a [routerLink]="['/home/dashboard']"><em nz-icon nzType="home"></em></a>
    </nz-breadcrumb-item>
    <nz-breadcrumb-item>
      <em nz-icon nzType="cluster"></em>
      Marketplaces
    </nz-breadcrumb-item>
    <nz-breadcrumb-item>Banners</nz-breadcrumb-item>
  </nz-breadcrumb>
</nz-page-header>

<div class="create-button">
  <button nz-button [nzType]="'primary'" [nzSize]="'large'" (click)="goToCreate()">
    <em nz-icon nzType="plus"></em>
    <span>Criar Novo Banner</span>
  </button>
</div>

<nz-table
  #basicTable
  [nzData]="rows"
  [nzLoading]="isLoading"
  [nzScroll]="{ x: '900px' }"
  [nzHideOnSinglePage]="true"
  [nzPageSize]="10"
  nzBordered>
  <thead>
    <tr>
      <th nzWidth="80px">Posição</th>
      <th>Título</th>
      <th nzWidth="220px">Produto</th>
      <th nzWidth="220px">Perfis</th>
      <th nzWidth="110px">Status</th>
      <th nzWidth="120px">Ações</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let banner of basicTable.data">
      <td>{{ banner.position }}</td>
      <td>{{ banner.title }}</td>
      <td>{{ banner.productLabelText }}</td>
      <td>{{ banner.rolesText }}</td>
      <td>
        <nz-tag [nzColor]="banner.isActive ? 'green' : 'default'">{{ banner.isActive ? 'Ativo' : 'Inativo' }}</nz-tag>
      </td>
      <td>
        <button nz-button nzType="link" nz-tooltip nzTooltipTitle="Editar" (click)="goToEdit(banner)">
          <em nz-icon nzType="edit"></em>
        </button>
        <button
          nz-button
          nzType="link"
          nzDanger
          nz-tooltip
          nzTooltipTitle="Excluir"
          nz-popconfirm
          nzPopconfirmTitle="Excluir este banner?"
          (nzOnConfirm)="deleteBanner(banner)">
          <em nz-icon nzType="delete"></em>
        </button>
      </td>
    </tr>
  </tbody>
</nz-table>
